import axios from "axios";
import { toast } from 'react-toastify';
// const API = axios.create({ baseURL: 'https://multiapi.wmdfms.org/' });
const API = axios.create({ baseURL: 'https://api.swsmfms.org/' });
// const API = axios.create({baseURL: "https://api.upcbfms.org/"});
// const API = axios.create({baseURL: "http://localhost/fms_backend/"});
const handleApiError = (error) => {
    if (error.response && error.response.status === 401) {
        let consent = localStorage.getItem('app_location_consent');
        sessionStorage.clear();
        localStorage.clear();
        localStorage.setItem('app_location_consent', consent);
        // debugger;
        window.location.href = "/login";
        return;
        
    }
    if(error.response && error.response.status === 429) {
        toast.error('Api Rate Limit Exceeds', {
            position: toast.POSITION.TOP_CENTER
        });
        return;
    }
    return Promise.reject(error);
};

API.interceptors.response.use(response => {
    return response;
}, error => {
    return handleApiError(error);
});

export const setAuthToken = (token) => {
    if (token) {
        API.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    } else {
        delete API.defaults.headers.common['Authorization'];
    }
};

//user
export const login_user = (FormData) => API.post('users/site_login', FormData);
export const login_user_v2 = (FormData) => API.post('users/loginV2', FormData);
export const portalInfo = (FormData) => API.post('CronJob/portal_info', FormData);
export const login_user_via_send_otp = (FormData) => API.post('users/user_send_otp', FormData);
export const login_user_via_verify_otp = (FormData) => API.post('users/user_verify_otp', FormData);
export const login_user_via_verify_otpV2 = (FormData) => API.post('users/user_verify_otp_v2', FormData);
export const forget_password_via_verify_otp = (FormData) => API.post('users/forget_verify_otp', FormData);
export const get_users = (formData) => API.get('users/user', {
    params: {
        department_id: formData.department_id || '',
        searchStr: formData.searchStr || '',
        department_level: formData.department_level || '',
    }
});
export const get_department_users = (formData) => API.get('v2/user/allUsers', {
    params: {
        searchStr: formData.searchStr || '',
    }
});
export const get_user_by_id = (id) => API.get(`users/user/${id}`);
export const add_user = (formData) => API.post('users/user', formData);
export const map_user = (formData) => API.post('v2/user/map_user', formData);
export const add_department_user = (formData) => API.post('v2/user/create_user', formData);
export const update_user_by_id = (formData, id) => API.post(`users/update_user/${id}`, formData);
export const reset_user_by_id = (id) => API.post(`users/user_reset/${id}`);
export const delete_user_by_id = (formData, id) => API.post(`users/delete_user/${id}`, formData);
export const delete_user_role = (formData) => API.post(`v2/user/delete_role`, formData);
export const reset_password_code = () => API.get(`v2/user/reset_password_code`);
export const reset_password_verify = (formData) => API.post(`v2/user/verify_reset_password`,formData);

//scheme
export const get_schemes_flags = () => API.get(`v2/schemes/scheme_flags`);
export const get_schemes = (data) => API.get('schemes/scheme', {
    params: {
        // from_date: data?.from_date || '',
        // to_date: data?.to_date || '',
        search_str: data?.search_str || '',
        fy_id: data?.fy_id || '',
        // approved: data?.approved || '',
        // id: data?.id || '',
        department_id_input: data?.department_id || '',
    }
});
export const get_consolidated_schemes = (data) => API.get('v2/schemes/consolidated_scheme_report', {
    params: {
        // from_date: data?.from_date || '',
        // to_date: data?.to_date || '',
        search_str: data?.search_str || '',
        fy_id: data?.fy_id || '',
        // approved: data?.approved || '',
        // id: data?.id || '',
        department_id: data?.department_id || '',
    }
});

export const get_mpr = (data) => API.get('schemes/mpr', {
    params: {
        month: data?.month || '',
        fy_id: data?.fy_id || '',
        department_id: data?.department_id || '',
    }
});


export const get_mpr_expense = (data) => API.get('schemes/mpr_expense', {
    params: {
        month: data?.month || '',
        fy_id: data?.fy_id || '',
        department_id: data?.department_id || '',
    }
});
export const mpr_export = (data) => API.get('schemes/mpr_export', {
    params: {
        month: data?.month || '',
        fy_id: data?.fy_id || '',
        department_id: data?.department_id || '',
        export_type: data?.export_type || '',
    }
});

export const mpr_expense_export = (data) => API.get('schemes/mpr_expense_export', {
    params: {
        month: data?.month || '',
        fy_id: data?.fy_id || '',
        department_id: data?.department_id || '',
        export_type: data?.export_type || '',
    }
});
export const get_schemes_details_by_id = (id) => API.get(`schemes/scheme/${id}`);
export const add_schemes = (formData) => API.post('schemes/scheme', formData);
export const update_scheme_by_id = (formData, id) => API.post(`schemes/update_scheme/${id}`, formData);
export const delete_scheme_by_id = (formData) => API.post('schemes/delete_scheme', formData);
export const update_scheme_status = (formData) => API.post('schemes/scheme_status_update', formData);
export const add_budget = (formData) => API.post('schemes/add_budget', formData);
export const update_budget_by_id = (formData) => API.post('schemes/update_budget', formData);
export const delete_budget_by_id = (formData) => API.post('schemes/delete_budget', formData);
export const get_budget_list = (formData, id) => API.post(`schemes/get_budget_list/${id}`, formData);
export const update_budget_status = (formData) => API.post('schemes/budget_status_update', formData);
export const generate_xml_of_payment_by_scheme_id = (formData) => API.post('schemes/generate_xml_of_scheme_payment', formData);
export const download_xml_as_zip = () => API.get('schemes/download_xml_as_zip');

export const get_schemes_by_fy = (scheme_id = 0, fy_id = 0, department_id) => API.get(`schemes/scheme_details_by_fy/${scheme_id}/${fy_id}`, {
    params: {
        department_id: department_id || ''
    }
});
export const get_schemes_by_fy_added_pending = (scheme_id = 0, fy_id = 0) => API.get(`schemes/scheme_details_by_fy_added_pending/${scheme_id}/${fy_id}`);

//beneficiary
export const get_beneficiary = (data) => API.get('beneficiary/beneficiary', {
    params: {
        from_date: data?.from_date || '',
        to_date: data?.to_date || '',
        search_str: data?.search_str || '',
        department_id: data?.department_id || '',
        type: data?.type || ''
    }
});
export const get_beneficiary_by_id = (id) => API.get('beneficiary/beneficiary/' + id);
export const add_beneficiary = (formData) => API.post('beneficiary/beneficiary', formData);
export const update_beneficiary_by_id = (formData) => API.post('beneficiary/update_beneficiary', formData);
export const delete_beneficiary_by_id = (formData) => API.post('beneficiary/delete_beneficiary', formData);
export const update_beneficiary_status = (formData) => API.post('beneficiary/beneficiary_status_update', formData);


//sanction order
export const add_sanction_order = (formData) => API.post('sanctions_order/sanction_order', formData);
export const get_invoices_by_invoice_no = (formData) => API.post('sanctions_order/invoice_list_by_invoice_no', formData);
export const get_invoice_details_by_invoice_id = (invoice_id) => API.get(`sanctions_order/invoice_details/${invoice_id}`);
export const delete_sanction_order = (invoice_id) => API.get(`sanctions_order/delete_invoice/${invoice_id}`);


// fund invocie list
export const get_fund_invoices = (data) => API.post(`sanctions_order/invoices`, data);
export const get_disbursment_invoices = (data) => API.post('sanctions_order/disbursment_invoice', data);
export const get_payment_invoices = (data) => API.post('sanctions_order/payment_invoices', data);
export const update_invoice_approvalStatus = (formData) => API.post('sanctions_order/update_invoice_approval_status', formData);
export const update_invoice_paymentStatus = (formData) => API.post('sanctions_order/update_invoice_payment_status', formData);
export const update_invoice = (formData) => API.post('sanctions_order/edit_invoice', formData);
export const get_consolidate_disbursment_invoices = (data) => API.post('sanctions_order/consolidate_invoices', data);
// dashboard
export const get_dashboard_data = (data) => API.get(`dashboard/dashboard`, {
    params: {
        fy_id: data?.fy_id || '',
        department_id: data?.department_id || '',
        department_level: data?.department_level || ''
    }
});
// export const add_account_balance_interest = (formData) => API.post('dashboard/add_account_balance_interest', formData);
export const add_account_balance_interest = (formData) => API.post('v2/schemes/create_scheme_account', formData);
export const update_account_balance_interest = (formData, id) => API.post(`v2/schemes/update_scheme_account/${id}`, formData);
export const get_account_balance_interest = () => API.get('dashboard/account_balance_interest',);

// utils
export const get_financial_year = () => API.get('utils/financial_year');
export const get_scheme_type = () => API.get('utils/scheme_type');
export const get_beneficiary_status = () => API.get('utils/beneficiary_status');
export const get_states = () => API.get('utils/states');
export const get_districts_list = (state_id) => API.get(`utils/districts/${state_id}`);
export const send_otp = (formData) => API.post(`utils/send_otp`, formData);
export const verify_otp = (formData) => API.post(`utils/verify_otp`, formData);

// budget reappropriate
export const add_budget_reappropriate = (formData) => API.post(`v2/BudgetReappropriate/create`, formData);
export const get_budget_reappropriate = () => API.get(`v2/BudgetReappropriate/list`);
export const get_single_budget_reappropriate = (id) => API.get(`v2/BudgetReappropriate/single/${id}`);
export const add_budget_reappropriate_subhead = (formData, id) => API.post(`v2/BudgetReappropriate/create_to_subhead/${id}`, formData);

// budget surrender
export const add_budget_surrender = (formData) => API.post(`v2/multi/BudgetSurrender/create`, formData);

export const approve_budget_surrender = (formData) => API.post(`v2/multi/BudgetSurrender/budget_surrender_action`, formData);
export const get_budget_surrender = (payload) => API.get(`v2/multi/BudgetSurrender/fetch_budget_surrender`, {
    params: payload
});

export const get_budget_surrender_by_id = (id) => API.get(`v2/multi/BudgetSurrender/fetch_budget_surrender_by_id/${id}`, {
    params: {}
});

export const add_beneficiary_reimbursement = (formData) => API.post(`v2/BeneficiaryReimbursement/create`, formData);
export const edit_beneficiary_reimbursement = (formData) => API.post(`v2/BeneficiaryReimbursement/edit`, formData);
export const add_beneficiary_reimbursement_beneficiaries = (formData, id) => API.post(`v2/BeneficiaryReimbursement/create_beneficiary_details/${id}`, formData);
export const get_beneficiary_reimbursement = (data) => API.get(`v2/BeneficiaryReimbursement/list`, {
    params: {
        from_date: data.from_date,
        to_date: data.to_date,
        search_str: data.search_str || '',
        dateColumn: data.dateColumn || '',
        listType: data.listType || '',
        department_id: data.department_id || '',
        is_all: data.is_all || '',
    }
});
export const get_single_beneficiary_reimbursement = (id) => API.get(`v2/BeneficiaryReimbursement/single/${id}`);
export const update_beneficiary_reimbursement_approval = (formData, id) => API.post(`v2/BeneficiaryReimbursement/approval_status/${id}`, formData);
export const update_beneficiary_reimbursement_payment = (formData, id) => API.post(`v2/BeneficiaryReimbursement/payment_status/${id}`, formData);
export const update_other_departments_reimbursement_approval = (formData) => API.post(`v2/BeneficiaryReimbursement/other_department_approval`, formData);
export const getBeneficiaryApprovalStatus = (id) => API.get(`v2/BeneficiaryReimbursement/get_reimbursement_approval_status/${id}`);

// Challan
export const getHeadOfAccounts = () => API.get(`v2/Headofaccounts`);
export const addChallan = (formData) => API.post('v2/Challans', formData);
export const addDepository = (formData) => API.post('v2/Depository/create', formData);
export const addBeneficiaryAccount = (formData) => API.post('beneficiary/beneficiary_bank', formData);
export const changeBeneficiaryStatus = (id, status) => API.post(`beneficiary/change_account_status/${id}/${status}`);
export const changeBeneficiaryAccountStatus = (formData) => API.post(`beneficiary/change_account_approval_status`, formData);
export const getChallans = () => API.get(`v2/Challans`);

export const getInvoiceTDS = (data) => API.get(`v2/Invoice/invoice_tds`, {
    params: {
        from_date: data.from_date,
        to_date: data.to_date,
        nps: data.nps,
        gis: data.gis,
        gst: data.gst,
        other: data.other,
        tds: data.tds,
        royalty: data.royalty,
        labour_cess: data.labour_cess,
        search_str: data.searchStr,
        dateColumn: data.dateColumn || '',
    }
});

// invoice_other_challans

export const getAccumulatedDeductions = (data) => API.get(`v2/Invoice/accumulated_deductions`, {
    params: {
        from_date: data.from_date,
        to_date: data.to_date,
        search_str: data.search_str || '',
        dateColumn: data.dateColumn || '',
        report: data.report || '',
        department_id: data.department_id || '',
    }
});

export const getTDSReports = (data) => API.get(`v2/Invoice/invoice_tds_challans`, {
    params: {
        // from: data.from,
        from_date: data.from_date,
        to_date: data.to_date,
        // search_str: data.searchStr || '',
        // dateColumn: data.dateColumn || '',
        search_str: data.search_str || '',
        fy_id:data.fy_id,
        department_id: data.department_id || '',
        parent_department_id:data.parent_department_id||""
    }
});

export const getGISReports = (data) => API.get(`v2/Invoice/invoice_gis_challans`, {
    params: {
        from_date: data.from_date,
        to_date: data.to_date,
        search_str: data.searchStr,
        dateColumn: data.dateColumn || '',
        department_id: data.department_id || '',
        parent_department_id:data.parent_department_id||""
    }
});

export const getGSTReports = (data) => API.get(`v2/Invoice/invoice_gst_challans`, {
    params: {
        // from_date: data.from_date,
        // to_date: data.to_date,
        // search_str: data.searchStr,
        // dateColumn: data.dateColumn || '',
        search_str: data.search_str || '',
        fy_id: data.fy_id || '',
        department_id: data.department_id || '',
        parent_department_id:data.parent_department_id
    }
});

export const getDepositoryReports = (data) => API.get(`v2/Depository/records`, {
    params: {
        from_date: data.from_date,
        to_date: data.to_date,
        search_str: data.search_str || '',
        dateColumn: data.dateColumn || '',
    }
});

export const getOTHERReports = (data) => API.get(`v2/Invoice/invoice_other_challans`, {
    params: {
        from_date: data.from_date,
        to_date: data.to_date,
        search_str: data.searchStr,
        dateColumn: data.dateColumn || '',
        department_id:data.department_id || '',
        parent_department_id:data.parent_department_id
    }
});

export const getNPSReports = (data) => API.get(`v2/Invoice/invoice_nps_challans`, {
    params: {
        from_date: data.from_date,
        to_date: data.to_date,
        search_str: data.searchStr,
        dateColumn: data.dateColumn || '',
        department_id:data.department_id || '',
        parent_department_id:data.parent_department_id
    }
});

export const getChallanDetails = (id) => API.get(`v2/Challans/single/${id}`);
export const updateChallan = (formData, id) => API.post(`v2/Challans/edit/${id}`, formData);
export const l1_l2_status = (formData) => API.post(`v2/Challans/l2_l3_Approval`, formData);
export const get_tds_codes = () => API.get('/v2/Invoice/tdc_codes');
// Reports
export const getInterestReports = (data) => API.get(`v2/Report/interest`, {
    params: {
        from_date: data.from_date || '',
        to_date: data.to_date || '',
        search_str: data.search_str || '',
        fy_id: data.fy_id || '',
        department_id_input: data.department_id || '',
        parent_department_id:data.parent_department_id
    }
});

export const getXmlReports = (data) => API.get(`v2/Report/xml_reporting`, {});
export const getBeneficiaryReports = (id, data) => API.get(`v2/Beneficiary/beneficiary_report`, {
    params: {
        beneficiary_id: id,
        from_date: data.from,
        to_date: data.to
    }
});
export const getSchemeSubheadReports = (id, data) => API.get(`v2/Schemes/schemes_subhead_report`, {
    params: {
        scheme_id: id,
        from_date: data.from,
        to_date: data.to
    }
});
export const downloadExcel = (url, data) => API.get(url, {
    params: {
        from_date: data.from_date || '',
        to_date: data.to_date || '',
        search_str: data.search_str || '',
        dateColumn: data.dateColumn || '',
    }
});

export const addTDSChallan = (formData) => API.post('v2/Invoice/create_tds_challan', formData);

export const addGISChallan = (formData) => API.post('v2/Invoice/create_gis_challan', formData);
export const addNPSChallan = (formData) => API.post('v2/Invoice/create_nps_challan', formData);

export const addOtherChallan = (formData) => API.post('v2/Invoice/create_other_challan', formData);
export const addGSTChallan = (formData) => API.post('v2/Invoice/create_gst_challan', formData);

export const getSchemeAccountBalances = (data) => API.get('v2/schemes/list_scheme_accounts', {
    params: {
        department_id: data?.department_id || '',
        financial_year: data?.fy_id || '',
    }
});
export const updateSchemeBankAccountApproval = (formData, $id) => API.post(`v2/schemes/update_bank_account_approval/${$id}`, formData);
// department Module
export const get_departments = (data) => API.get('v2/multi/Department_details', {
    params: {
        id:data?.id,
        department_level: data.department_level || '',
        active_scheme_account_id: data.active_scheme_account_id || '',
        searchStr: data.searchStr || '',
        parent_department_id: data.parent_department_id || '',
        all: data.all || '',
    }
});
export const get_my_departments = () => API.get('v2/user/getMyDepartments');
export const switch_department = (formData) => API.post('v2/user/switchDepartment',formData);
export const get_departmentDetail = (data) => API.get('v2/multi/Department_details', {
    params: {
        id: data.id || '',
    }
});
export const addDepartment = (formData) => API.post('v2/multi/Department_details/create', formData);
export const editDepartment = (formData, id) => API.post(`v2/multi/Department_details/edit/${id}`, formData);
//Activity Apis
export const addActivity = (formData) => API.post('v2/multi/Activity', formData);
export const editActivity = (formData, id) => API.post(`v2/multi/Activity/edit/${id}`, formData);
export const getActivity = (id) => API.get(`v2/multi/Activity`, {
    params: {
        id: id || '',
    }
})
//Sub Activity Apis
export const AddSubActivity = (formData) => API.post('v2/multi/Activity/subactivities', formData);
export const editSubActivity = (formData, id) => API.post(`v2/multi/Activity/edit/subactivities/${id}`, formData);
export const getSubActivity = (formData) => API.get(`v2/multi/Activity/subactivities`, {
    params: {
        activity_id: formData?.id || '',
        searchStr: formData?.searchStr
    }
})

// budget Allocation
export const AddAllocateBudget = (formData) => API.post('v2/multi/Allocate_budget/create', formData);
export const EditAllocateBudgetApi = (formData) => API.post('v2/multi/Allocate_budget/edit', formData);
export const UploadAllocateBudgetDoc = (formData) => API.post('v2/multi/Allocate_budget/upload_doc', formData);
export const getAllocateBudgetList = (data) => API.get(`v2/multi/Allocate_budget/fetch_allocate_budgets`, {
    params: {
        id: data?.id || '',
        pending: data?.pending || '',
        approval: data?.approval || '',
        department_id: data?.department_id || '',
        is_all: data?.all || '',
        from_date: data?.from_date || '',
        to_date: data?.to_date || '',
        search_str: data?.search_str || '',
        fy_id: data?.fy_id || '',
    }
})
export const approve_allocate_budget = (data, id) => API.post(`v2/multi/Allocate_budget/approval_status/${id}`, data);
// child Bank Account Apis
export const AddBankAccount = (formData) => API.post('v2/schemes/create_scheme_account', formData);
export const getBankAccountList = (formData) => API.get(`v2/schemes/list_scheme_accounts`, {
    params: {
        childrens: true,
        searchStr: formData.searchStr || '',
        department_level: formData.tier || '',
        department_id: formData.department_id || ''
    }
})
export const getBankAccountById = (id) => API.get(`v2/schemes/fetch_bank_account_by_id/${id}`, {
    params: {}
})
// child scheme bank Account Apis
export const AddSchemeBankAccount = (formData) => API.post('v2/schemes/map_child_scheme_account', formData);
export const getSchemeBankAccountList = (formData) => API.get(`v2/schemes/map_child_scheme_account`, {
    params: {
        searchStr: formData.searchStr || '',
        department_level: formData.tier || '',
        department_id: formData.department_id || ''
    }
})

// Challan APi

export const getChallanData = (formData) => axios.create({baseURL: 'http://65.0.24.174:3100/'}).post(`get_challan_data`, formData);

export const getPPAList = (data) => API.get(`schemes/ppa`, {
    params: {
        batch_id: data?.batch_id || '',
        from_date: data.from_date || '',
        to_date: data.to_date || '',
    }
});

export const getBeneficiaryPPAList = (data) => API.get(`v2/multi/ppa/fetch_beneficiary_ppa`, {
    params: {
        department_id: data?.department_id || '',
        from_date: data.from_date || '',
        to_date: data.to_date || '',
        limit: data.limit || 10,
        offset: data.offset || 1,
        parent_department_id: data.parent_department_id || '',
        search_str: data.search_str || '',
    }
});

export const getBeneficiaryPPATrail = (data) => API.get(`v2/multi/ppa/fetch_online_payment_trail`, {
    params: {
        ppa_invoice_batch_id: data?.ppa_invoice_batch_id || '',
        account_no: data.account_no || '',
    }
});
// fetch_online_payment_trail
export const getConsolidateBeneficiaryPPAList = (data) => API.get(`v2/multi/ppa/fetch_beneficiary_ppa_consolidate`, {
    params: {
        department_id: data?.department_id || '',
        from_date: data.from_date || '',
        to_date: data.to_date || '',
        limit: data.limit || 10,
        offset: data.offset || 1,
        parent_department_id: data.parent_department_id || '',
        search_str: data.search_str || '',
    }
});

export const getExportBeneficiaryPPAList = (data) => API.get(`v2/multi/ppa/export_beneficiary_ppa`, {
    params: {
        department_id: data?.department_id || '',
        from_date: data.from_date || '',
        to_date: data.to_date || '',
        parent_department_id: data.parent_department_id || '',
        search_str: data.search_str || '',
        subactivity_reporting: data.subactivity_reporting || '',
        ppa_invoice_batch_ids: data.ppa_invoice_batch_ids || '',
    }
});

export const getExportConsolidateBeneficiaryPPAList = (data) => API.get(`v2/multi/ppa/export_consolidated_beneficiary_ppa`, {
    params: {
        department_id: data?.department_id || '',
        from_date: data.from_date || '',
        to_date: data.to_date || '',
        parent_department_id: data.parent_department_id || '',
        search_str: data.search_str || '',
    }
});


export const downloadPPA = (formData) => API.post(`schemes/download_ppa`, formData);


//tds Section and Rate Apis
export const get_Tds_Section = () => API.get(`sanctions_order/tds_sections`)
export const get_Tds_Rate = (id) => API.get(`sanctions_order/tds_sections_amount/${id}`);

export const send_otp_forget_password = (formData) => API.post(`users/user_forget_send_otp`, formData);
export const add_subhead_budget = (formData) => API.post(`schemes/create_subhead`, formData);

// check reimbursement beneficiary
export const check_reimbursement_beneficiary = (formData) => API.post(`v2/BeneficiaryReimbursement/verifyBeneficiaries`, formData);
export const get_reimbursement_schemes = () => API.get(`v2/BeneficiaryReimbursement/schemes`);

// royalty payment
export const getAuthorities = (data) => API.get(`v2/Invoice/authorities`, {
    params: {}
});

export const createRoyaltyChallan = (data) => API.post(`v2/Invoice/create_royalty_challan`, data);
export const getRoyaltyDetails = (challanNo) => API.get(`v2/Invoice/royalty_details/${challanNo}`);
export const approveRoyalty = (data) => API.post(`v2/Invoice/royalty_challan_approval`,data);
export const createLabourCessChallan = (data) => API.post(`v2/Invoice/create_labour_cess_challan`, data);
export const getRoyaltyPaymentList = () => API.get(`v2/Invoice/royalty_payment_pending`);
export const getRoyaltyPaymentOtp = () => API.get(`v2/Invoice/royalty_payment_otp`);
export const approveRoyaltyPayment = (data) => API.post(`v2/Invoice/royalty_payment_approval`,data);

export const getLabourcessDetails = (challanNo) => API.get(`v2/Invoice/labour_details/${challanNo}`);
export const approveLabour = (data) => API.post(`v2/Invoice/labour_challan_approval`,data);
export const getLabourPaymentList = () => API.get(`v2/Invoice/labour_payment_pending`);
export const getLabourPaymentOtp = () => API.get(`v2/Invoice/labour_payment_otp`);
export const approveLabourPayment = (data) => API.post(`v2/Invoice/labour_payment_approval`,data);
export const getPendingRoyaltyChallan = (data) => API.get(`v2/Invoice/royalty_pending_challans`, {
    params: {
        from_date: data.from_date,
        to_date: data.to_date,
        search_str: data.searchStr,
        user_type: data.user_type,
        // dateColumn: data.dateColumn || '',
    }
});
export const getPendingLabourCessChallan = (data) => API.get(`v2/Invoice/labour_pending_challans`, {
    params: {
        from_date: data.from_date,
        to_date: data.to_date,
        search_str: data.searchStr,
        user_type: data.user_type,
        // dateColumn: data.dateColumn || '',
    }
});

export const getRoyaltyChallan = () => API.get(`v2/Invoice/royalty_challans`, {});
export const getLabourCessChallan = () => API.get(`v2/Invoice/labour_challans`, {});


export const getAuthoritieAccounts = (id) => API.get(`v2/Invoice/authority_accounts/${id}`, {
    params: {}
});
export const createAuthority= (data) => API.post(`v2/Invoice/create_authority`,data);

export const getUserFullDetailsById = (id) => API.post(`v2/user/user_details_by_id`, {id: id});

export const getUtilizedBudget = (fyId , monthId, department_id) => API.get(`dashboard/get_utilized_budget_list`, {
    params:{
        fy_id:fyId,
        month:monthId || '',
        department_id: department_id
    }
});

export const getAccomulateDeduction = ({fyId, department_id}) => API.get(`/dashboard/get_dashboard_accomulated_deduction`, {
    params:{
        fy_id:fyId || '',
        department_id: department_id || ''
    }
});
export const getReconcilation = ({fyId, department_id}) => API.get(`/dashboard/get_dashboard_reconcilation`, {
    params:{
        fy_id:fyId || '',
        department_id: department_id || ''
    }
});

export const getSchemeBudget = (fyId , department_id, balance) => API.get(`/v2/schemes/fetch_scheme_budgets` , {
    params:{
        fy_id:fyId || '',
        department_id:department_id || '',
        balance: balance || false
    }
})
export const getMonthUtilization = (fyId , monthId, department_id) => API.get(`/dashboard/get_monthly_utilization` , {
    params:{
        fy_id:fyId || '',
        month:monthId || '',
        department_id:department_id || ''
    }
})
export const exportSubactivityReport = (data) => API.get(`schemes/subactivity_report`, {
    params: {
        fy_id: data.fy_id,
        department_level: data.department_level,
    }
});

export const getInvoicesBySchemeId = ({ scheme_id, fy_id, department_id }) => API.get(`sanctions_order/fetch_scheme_invoices`, {
    params: {
        scheme_id: scheme_id || '',
        financial_year_id: fy_id || '',
        department_id: department_id || '',
    }
});

export const getReimbursementBySchemeId = ({ scheme_id, fy_id, department_id }) => API.get(`v2/BeneficiaryReimbursement/fetch_beneficiary_reimbursement_by_scheme_id`, {
    params: {
        scheme_id: scheme_id || '',
        financial_year_id: fy_id || '',
        department_id: department_id || '',
    }
});

export const getAllocationBudgetBySchemeId = ({ scheme_id, fy_id, parent_department_id, department_id }) => API.get(`v2/multi/Allocate_budget/fetch_allocate_budgets_by_scheme_id`, {
    params: {
        scheme_id: scheme_id || '',
        fy_id: fy_id || '',
        parent_department_id: parent_department_id || '',
        department_id: department_id || '',
    }
});


export const getBeneficiaryReappropriationBySchemeId  = ({ scheme_id, fy_id, parent_department_id, department_id }) => API.get(`v2/BudgetReappropriate/fetch_beneficiary_reappropriation_by_scheme_id`, {
    params: {
        scheme_id: scheme_id || '',
        fy_id: fy_id || '',
        parent_department_id: parent_department_id || '',
        department_id: department_id || '',
    }
});

export const fetchDepartmentSurrenderBudgets = ({scheme_id, fy_id, department_level}) => API.get(`schemes/fetch_surrender_budget`, {
    params: {
        scheme_id: scheme_id || '',
        fy_id: fy_id || '',
        department_level: department_level || ''
    }
});

export const uploadFile = (formData) => API.post(`/FileUpload/upload`, formData);

export const fetchSchemesOnly = () => API.get(`schemes/fetch_schemes_only`, {
    params: {}
});
export const userLogout = () => API.get(`users/user_logout`, {
    params: {}
});

export const createSalary = (formData) => API.post(`/v2/Salary`, formData);
export const getSalaries = (formData) => API.get(`/v2/Salary`, {
    params: {
        department_id: formData.department_id || '',
        fy_id: formData.fy_id || '',
        payment: formData.payment || '',
        pending: formData.pending || '',
        isAll: formData.isAll || '',
        approved: formData.approved || '',
        scheme_id: formData.scheme_id || '',
        approveonly: formData.approveonly || '',
    }
});

export const getSalaryDetails = (salary_id) => API.get(`/v2/Salary/fetch_salary/${salary_id}`, {});

export const salaryApproval = (formData) => API.post(`/v2/Salary/salary_approval`, formData);
export const updateSalaryPayment = (formData, id) => API.post(`/v2/Salary/update_salary_payment/${id}`, formData);

// bank settlement apis

export const BankSettlementMail = () => API.get(`/v2/multi/BankSettlement/fetch_bank_mails`, {});
export const BankSettlementBeneficiaries = (formData) => API.get(`/v2/multi/BankSettlement/fetch_bank_settlement_beneficiaries`, { params: {
    bankSettlementId: formData.bankSettlementId || '',
    approved: formData.approved || '',
    rejected: formData.rejected || '',
    onHold: formData.onHold || '',
    details: formData.details || ''
} });

export const fetchConsolidateDashboard = (formData) => API.get(`/v2/multi/ConsolidateReport`, { params: {
    financial_year_id: formData.financial_year_id || '',
} });

export const exportConsolidateDashboard = (formData) => API.get(`/v2/multi/ConsolidateReport/export_consolidate`, { params: {
    financial_year_id: formData.financial_year_id || '',
} });

export const fetchBudgetSurrenderAcceptedList = (formData) => API.get(`/v2/multi/BudgetSurrender/fetch_budget_surrender_accepted`, { params: {
    financial_year_id: formData.financial_year_id || '',
    department_id: formData.department_id || '',
    subhead_id: formData.subhead_id || '',
    scheme_id: formData.scheme_id || '',
} });

export const fetchBudgetSurrenderDoneList = (formData) => API.get(`/v2/multi/BudgetSurrender/fetch_budget_surrender_done`, { params: {
    financial_year_id: formData.financial_year_id || '',
    department_id: formData.department_id || '',
    subhead_id: formData.subhead_id || '',
    scheme_id: formData.scheme_id || '',
} });

// delete ppa
export const deletePPA = (ppa_id) => API.get(`/v2/multi/ppa/deletePpa/${ppa_id}`,{});
export const fetchUpcomingPPA = () => API.get(`/v2/multi/ppa/fetch_upcoming_settlements`,{});
export const updateBankSettlements = (formData) => API.post(`/v2/multi/BankSettlement/update_bank_settlements`, formData);
export const fetchDefaultUser = (id) => API.get('users/fetch_default_user', {
    params: {
        id: id || ''
    }
});
export const sendOtpToDefaultUser = (formData) => API.post('users/send_otp_to_default_user', formData);
export const verifyOtpAndAddDefaultUser = (formData) => API.post('users/verify_create_default_user', formData);
export const verifyAdhaarCard = (formData) => API.post('users/verify_adhaar_card', formData);
export const fetchUserActivities = (ppa_id) => API.get(`/Users/fetch_user_activities`,{});

export const fetchFailedInvoices = () => API.get(`/v2/invoice/fetch_failed_invoices`,{});
export const fetchFailedInvoiceDetails = (id) => API.get(`/v2/invoice/fetch_failed_invoice_details/${id}`,{});

export const getBeneficiaryAccountListBeneficiaryId = (beneficiary_id) => API.get(`beneficiary/beneficiary_accounts/${beneficiary_id}`, {
    params: {}
});

export const createDuplicateInvoice = (formData) => API.post(`v2/invoice/create_duplicate_invoice`, formData);

export const getSubheadExpenses = (formData) => API.get(`v2/schemes/fetch_subhead_expense_breakup`, {
    params: {
        scheme_id: formData.scheme_id || '',
        department_id: formData.department_id || '',
        fy_id: formData.fy_id || '',
    }
});

export const fetchActivityExpenseBreakup = (formData) => API.get(`v2/schemes/fetch_activity_expense_breakup`, {
    params: {
        scheme_id: formData.scheme_id || '',
        department_id: formData.department_id || '',
        fy_id: formData.fy_id || '',
    }
});

export const verifyAadhaarSmartauth = (formData) => API.post(`utils/verify_aadhaar_smartauth`, formData);
export const getAadhaarVerificationStatus = (transaction_id) => API.get(`utils/fetch_adhaar_verification_status/${transaction_id}`, {});

export const exportSubActivityDetailedReport = (department_id) => API.get(`schemes/export_scheme/${department_id}`, {});

export const updateSchemePaymentMethod = (formData) => API.post(`v2/schemes/update_scheme_payment_method`, formData);

export const updateSchemeExpenseConfig = (formData) => API.post(`v2/schemes/update_scheme_expense_type`, formData);